import type { GetNotificationById200SourceSourceUser } from './getNotificationById200SourceSourceUser';

/**
 * 알림 소스 정보
 */
export type GetNotificationById200Source = {
  /** 알림을 발생시킨 사용자 정보 */
  sourceUser?: GetNotificationById200SourceSourceUser;
  /** 알림을 발생시킨 사용자 ID */
  sourceUserId?: number;
};
